angular
    .module('cabinetApp')
    .controller('windowsCTRL', function windowsCTRL($scope, $http, $rootScope, $timeout, requestsModel, ticketsModel, utilities) {
        $scope['loader']            = {};
        $scope['loader']['show']    = false;

        $scope['windows']         = {};
        $scope['windows']['show'] = false;
        $scope['pageId']          = null;

        $scope['newSupport']            = {};
        $scope['newSupport']['files']   = [];
        $scope['newSupport']['body']    = '';
        $scope['newSupport']['counter'] = 0;

        $scope['newTickets']               = {};
        $scope['newTickets']['counter']    = 0;
        $scope['newTickets']['files']      = [];
        $scope['newTickets']['type']       = null;
        $scope['newTickets']['department'] = null;

        $scope['newRequest']            = {};
        $scope['newRequest']['counter'] = 0;
        $scope['newRequest']['files']   = [];
        $scope['newRequest']['homeTel'] = '';
        $scope['newRequest']['mobyTel'] = '';
        $scope['newRequest']['workTel'] = '';

        // Закрыть окно
        $scope.closeWindow = function() {
            if ($scope['windows']['from'] === 'lastNews' ) {
                $scope.markReaNews();
            }

            $scope['windows']         = {};
            $scope['windows']['show'] = false;
        };

        // Окно новых новостей. Пометить прочитанным новость
        $scope.markReaNews = function() {
            var params = {};
                params['index'] = $scope['windows']['index'];

            $rootScope.$broadcast('widgetsMarkReadNews', params);

            if ($scope['windows']['next']) {
                $scope.changeNews('next');
            }
        };

        // Окно новостей. Переключить номер.
        $scope.changeNews = function(type) {
            var params = {};
                params['type']  = type;
                params['from']  = $scope['windows']['from'];
                params['index'] = $scope['windows']['index'];

            $rootScope.$broadcast($scope['pageId'] + 'ChangeNews', params);
        };

        // Окно технической поддержки. Добавить файл
        $scope.addSupportFile = function(file) {
            $scope['newSupport']['files'].push({
                counter: 'new:' + $scope['newSupport']['counter'],
                name: file['name'],
                file: file
            });

            $scope['newSupport']['counter'] += 1;
        };

        // Окно технической поддержки. Удалить файл
        $scope.removeSupportFile = function(index) {
            $scope['newSupport']['files'].splice(index, 1);
        };

        // Окно технической поддержки. Отправить сообщение
        $scope.sendSupport = function() {
            var supportText  = $.trim($scope['newSupport']['body']);
            var supportForm  = new FormData();
            var newSupport = {};
                newSupport['subject'] = supportText.length > 50 ? supportText.substring(0, 50) + '...' : supportText;
                newSupport['initial'] = {};
                newSupport['initial']['is_published'] = true;
                newSupport['initial']['body'] = supportText;
                newSupport['initial']['files'] = [];
                newSupport['_type'] = 'SupportTicket';
                newSupport['type']  = 'cabinet';

            $scope['newSupport']['files'].forEach(function(item) {
                newSupport['initial']['files'].push({
                    uuid: item['counter']
                });

                supportForm.append(item['counter'], item['file']);
            });

            supportForm.append('body', JSON.stringify(newSupport, null, '\t'));

            utilities.loader(true);
            ticketsModel.sendForm(supportForm, 'support/', function() {
                utilities.loader();

                $scope['newSupport']['body']  = '';
                $scope['newSupport']['files'] =  [];

                utilities.removeLocalDataByType('tickets');

                $scope.closeWindow();
                $rootScope.$broadcast('ticketsSendTicket');
            });
        };

        $scope.file = null;
        $scope.files = [];

        // Окно нового обращения. Добавить файл
        $scope.addTicketsFile = function(file) {
            $scope.files.push(file);
        };

        // Окно нового обращения. Удалить файл
        $scope.removeTicketsFile = function(index) {
            //$scope['newTickets']['files'].splice(index, 1);
            $scope.files.splice(index, 1);
        };

        $scope.sendTicket = function(){
            var params = {
                type: $scope.newTickets.type.value,
                body: $scope.newTickets.body,
                department: $scope.newTickets.department.id
            };
            ticketsModel.sendForm(params, function(response){
                var formData = new FormData();
                if($scope.files.length){
                    for(var i = 0, length = $scope.files.length; i < length; i++){
                        formData.append('file__'+i, $scope.files[i]);
                    }
                    ticketsModel.sendFiles(formData, response.data.id, function(){
                        $rootScope.$broadcast('ticketsSendTicket');
                    }, function(){
                        $rootScope.$broadcast('ticketsSendTicket');
                    });
                } else {
                    $rootScope.$broadcast('ticketsSendTicket');
                }
            });
            $scope.closeWindow();
        };

        // Окно новой заявки. Добавить файл
        $scope.addRequestFile = function(file) {
            $scope['newRequest']['files'].push({
                counter: 'new:' + $scope['newRequest']['counter'],
                name: file.name,
                file: file
            });

            $scope['newRequest']['counter'] += 1;
        };

        // Окно новой заявки. Удалить файл
        $scope.removeRequestFile = function(index) {
            $scope['newRequest']['files'].splice(index, 1);
        };

        // Окно новой заявки. Отправить заявку
        $scope.sendRequest = function() {
            var requestForm  = new FormData();
            var newRequest   = {};
                newRequest['body']             = $.trim($scope['newRequest']['body']);
                newRequest['phones']           = [];
                newRequest['photos']           = [];
                newRequest['dt_desired_start'] = utilities.getStartDayIso();
                newRequest['dt_desired_end']   = newRequest['dt_desired_start'];

            if ($scope['newRequest']['workTel'] !== '' ) {
                newRequest['phones'].push({
                    type   : 'work',
                    code   : utilities.getPhoneCode($scope['newRequest']['workTel']),
                    number : utilities.getPhoneNumber($scope['newRequest']['workTel'])
                });
            }

            if ($scope['newRequest']['mobyTel'] !== '' ) {
                newRequest['phones'].push({
                    type   : 'cell',
                    code   : utilities.getPhoneCode($scope['newRequest']['mobyTel']),
                    number : utilities.getPhoneNumber($scope['newRequest']['mobyTel'])
                });
            }

            if ($scope['newRequest']['homeTel'] !== '' ) {
                newRequest['phones'].push({
                    type   : 'home',
                    code   : utilities.getPhoneCode($scope['newRequest']['homeTel']),
                    number : utilities.getPhoneNumber($scope['newRequest']['homeTel'])
                });
            }

            $scope['newRequest']['files'].forEach(function(item, index) {

                requestForm.append('photos__' + index, item['file']);
            });

            delete newRequest.photos;

            utilities.loader(true);

            return requestsModel.sendFormV4(newRequest, function(response) {
                $scope.responseId=response;
            })

                .then(function () {

                    if ($scope['newRequest']['files'].length < 1) {
                        return;
                    };

                    var url = '/api/v4/forms/tenant/requests/files/' + $scope.responseId + '/';

                    $http.patch(url, requestForm, {
                        transformRequest: angular.identity,
                        headers: {'Content-Type': undefined},
                        // params: params
                    })

                        .then(function () {
                        });
            })
                .then(function(){

                    utilities.loader();

                    $scope['newRequest']['files']   =  [];
                    $scope['newRequest']['body']    = '';
                    $scope['newRequest']['homeTel'] = '';
                    $scope['newRequest']['mobyTel'] = '';
                    $scope['newRequest']['workTel'] = '';

                    $scope.closeWindow();
                    $rootScope.$broadcast('requestsSendRequest');
                });
        };

        // Окно регистрации кабинета. Зарегистрировать
        $scope.registerLK = function() {
            var params = {};
                params['acc']  = $scope['windows']['acc'];
                params['fio']  = $scope['windows']['fio'];
                params['mail'] = $scope['windows']['mail'];

            $rootScope.$broadcast('headerRegisterLk', params);

            $scope.closeWindow();
        };

        $scope.currentCard = {
            number: null
        };

        $scope.makeAutoPay = function(sector, card, amount){
            var data = {
                sector: sector,
                card: card,
                amount: amount
            };
            return $http.post('/api/v4/billing/tenant/fast_transaction/', data).then(function(response){
                $rootScope.$broadcast('getAutoPaySettings');
            });
        };

        $scope.createNewSetting = function(sector, wantAutoPay, cardNumber){
            var data = {
                sector: sector,
                auto_pay: wantAutoPay,
                card: cardNumber
            };
            return $http.post('/api/v4/billing/tenant/pay_settings/', data);
        };

        /* Удаление карты */
        $scope.deleteCard = function (card, index) {
            if (confirm('Удалить карту?')) {
                utilities.loader(true);
                return $http.delete('/api/v4/billing/tenant/pay_settings/' + card._id + '/').then(function(response) {
                    utilities.loader(false);
                    $scope.currSettings.fastPay.splice(index, 1);
                })
            }
            //TODO: если импортнуть dialogs из основного проекта, тут станет красиво

            // var dlg = dialogs.confirm('Удаление банковской карты', 'Удалить карту?', 'sm');
            // dlg.result.then(function(btn){
            //     utilities.loader(true);
            //     return $http.delete('/api/v4/billing/tenant/pay_settings/' + card._id + '/').then(function(response) {
            //         utilities.loader(false);
            //         $scope.currSettings.fastPay.splice(index, 1);
            //     })
            // },function(btn){
            //
            // });
        };

        /* "Продолжить" в модальном окне автоплатежа */
        $scope.autopayContinue = function () {
            utilities.loader(true);
            $scope.wishes.autoPay = true;
            $scope.wishes.saveCard = true;
            $scope.paymentResume();
        };

        /* Срабатывает после нажатия кнопки "Оплатить" */
        $scope.paymentResume = function() {
            var window = Object.assign({}, $scope.windows);


            if(!$scope.wishes.autoPay && !$scope.wishes.saveCard && $scope.currentCard.number){
                // console.log('Хочу быстрый платеж');
                $scope.makeAutoPay(
                    $scope.currSettings.sector,
                    $scope.currentCard.number,
                    window.recipient.value
                )
            } else {
                if($scope.wishes.autoPay && $scope.currentCard.number){
                    // console.log('Хочу автоплатеж по уже имеющейся карте', $scope.currentCard.number)
                    $scope.createNewSetting(
                        $scope.currSettings.sector,
                        $scope.wishes.autoPay,
                        $scope.currentCard.number
                    )
                } else {
                    // console.log('Хочу сохранить первую карту/Подключить автоплатеж не имея ни одной карты/Добавляю новую карту');
                    if($scope.wishes.saveCard || $scope.currentCard.number === ''){
                        // Либо подключается автоплатеж, что понятно по saveCard, либо сохраняется/добавляется карта
                        $scope.createNewSetting(
                            $scope.currSettings.sector,
                            $scope.wishes.autoPay,
                            ''
                        ).then(function(response){
                            $rootScope.$emit(window['meta']['page'] + 'PaymentSend', window);
                        })
                    } else {
                        // console.log('Хочу просто заплатить')
                        $rootScope.$emit(window['meta']['page'] + 'PaymentSend', window);
                    }
                }
            }
            $scope.closeWindow();
        };

        // // Окно оплат. Оплатить / отправить
        // $scope.paymentResume = function(sector) {
        //     var window = Object.assign({}, $scope.windows);
        //     if($scope.currentCard.number && $scope.wishes.autoPay !== true){
        //         if($scope.windows['recipient']['value'].toString().trim().length === 0 || parseFloat($scope.windows['recipient']['value']).toFixed(2) === '0.00'){
        //             utilities.message('Указана некорректная сумма');
        //             return;
        //         } else {
        //             $scope.makeAutoPay(
        //                 $scope.currSettings.sector,
        //                 $scope.currentCard.number,
        //                 window.recipient.value
        //             );
        //         }
        //     } else if($scope.wishes.saveCard ||  $scope.currentCard.number === '' || $scope.currentCard.number){
        //         var data = {
        //             sector: $scope.currSettings.sector,
        //             auto_pay: $rootScope.wishes.autoPay,
        //             card: $scope.currentCard.number || ''
        //         };
        //         $http.post('/api/v4/billing/tenant/pay_settings/', data).then(function(response){
        //             if($scope.currentCard.number && $scope.currentCard.number.length && !$scope.wishesh.autoPay){
        //                 $scope.makeAutoPay(
        //                     $scope.currSettings.sector,
        //                     $scope.currentCard.number,
        //                     window.recipient.value
        //                 );
        //             }
        //             if($scope.currentCard.number === '' && $scope.wishes.autoPay === true){
        //                 $rootScope.$emit(window['meta']['page'] + 'PaymentSend', window);
        //             }
        //         })
        //     } else if($scope.currentCard.number === null){
        //         $rootScope.$emit(window['meta']['page'] + 'PaymentSend', window);
        //     }
        //     //$rootScope.$emit($scope['windows']['meta']['page'] + 'PaymentSend', $scope['windows']);
        //     $scope.closeWindow();
        // };

        $scope.$on('paymentModalOpened', function(event, data){
            $scope.currSettings = Object.assign({}, $rootScope.autoPaySettings[data.sector]);
            $scope.currSettings.sector = data.sector;
            $rootScope.currentCard = {
                number: ''
            };
            $scope.haveAutoPay = !_.isEmpty($scope.currSettings.autoPay);
            $scope.haveCards = $scope.currSettings.fastPay && $scope.currSettings.fastPay.length;
            $rootScope.wishes = {
                autoPay: false,
                saveCard: false
            };
            if($scope.haveAutoPay){
                $rootScope.currentCard.number = $scope.currSettings.autoPay.card;
            }
        });

        $rootScope.$on('disableAutoPay', function(event, data){
            if(data.setting){
                var params = data.setting;
                params.auto_pay = false;
                $http.post('/api/v4/billing/tenant/pay_settings/', params).then(function(response){
                    $rootScope.$broadcast('getAutoPaySettings');
                });
            }
        });

        // Команда открыть окно
        $rootScope.$on('openWindow', function(event, params) {
            $timeout(function() {
                $scope['pageId']  = params['data']['page'];
                $scope['windows'] = params['data'];
                $scope['windows']['type'] = params['windowName'];
                $scope['windows']['show'] = true;
            }, 100);
        });

        // Отслеживание получения пользовательской ифнормации
        $rootScope.$watch('user.info.accounts', function(data) {
            if (! $.isEmptyObject(data)) {
                $scope['newTickets']['type']       = $rootScope['constants']['ticketTypes'][0];
                $scope['newTickets']['department'] = $rootScope['dictionaries']['departments'][0];
            }
        });
    });
